import React, {ReactNode} from 'react';

import {Handler, HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {IconButton} from '../../../../libs/shared/ui/src/components/buttons/iconButton';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {SettingsCustomFieldsPagesEnum} from '../../../models/url/settingsUrlModel';
import {
  StyledSettingsContent,
  StyledSettingsMain,
  StyledSettingsSidebar,
  StyledSettingsWrapper,
} from '../../common/settingsWrapper';
import {customFieldPageToResourceTypeMap} from '../customFieldsHelpers';
import {CustomFieldsTableContainer} from '../table/customFieldsTableContainer';
import {CustomFieldsButtons} from './customFieldsButtons';
import {CustomFieldsListSidebarContainer} from './customFieldsListSidebarContainer';
import {CustomFieldsTabs} from './customFieldsTabs';

/*
 * Types.
 */

interface SettingsCustomFieldsListProps {
  tabPage: SettingsCustomFieldsPagesEnum;
  isSidebarOpen: boolean;
  toggleSidebar: Handler;
  setSuccessBannerMessage: HandlerOf<ReactNode>;
}

/*
 * Component.
 */

export const SettingsCustomFieldsList = ({
  tabPage,
  isSidebarOpen,
  toggleSidebar,
  setSuccessBannerMessage,
}: SettingsCustomFieldsListProps) => {
  const theme = useUserTheme();
  const renderRightHeader = () => (
    <IconButton
      iconName="info"
      label=""
      onClick={toggleSidebar}
      color={theme.greys.shade70}
      activeColor={theme.greys.shade70}
      hoverColor={theme.greys.shade70}
      hoverActiveColor={theme.greys.shade70}
      backgroundColor={isSidebarOpen ? theme.greys.shade30 : undefined}
      backgroundHoverColor={isSidebarOpen ? theme.greys.shade40 : theme.greys.shade30}
    />
  );

  return (
    <StyledSettingsWrapper>
      <CustomFieldsTabs tabPage={tabPage} right={renderRightHeader()} />
      <StyledSettingsMain>
        <StyledSettingsContent>
          <CustomFieldsButtons tabPage={tabPage} />
          <CustomFieldsTableContainer
            resourceType={customFieldPageToResourceTypeMap[tabPage]}
            tabPage={tabPage}
            onSuccessfulDelete={setSuccessBannerMessage}
          />
        </StyledSettingsContent>
        {isSidebarOpen && (
          <StyledSettingsSidebar>
            <CustomFieldsListSidebarContainer tabPage={tabPage} />
          </StyledSettingsSidebar>
        )}
      </StyledSettingsMain>
    </StyledSettingsWrapper>
  );
};
